import Vue from 'vue'
import merge from 'lodash/merge'

/**
 * Modal management
 */
export default {

    namespaced: true,

    state: {
        modals: [],
        modalIdx: 0,
    },

    getters: {

        modals (state) {
            return state.modals
        },

    },

    mutations: {},

    actions: {

        show (context, payload) {

            // Merge some defaults
            let modal = {
                dismissing: false,
                canDismiss: true,
                cancelLabel: 'Cancel Action',
                confirmLabel: 'Confirm Action',
                confirmMessage: 'Are you sure you want to do this?',
                data: null,
                maskCanDismiss: true,
                headless: false
            }

            merge(modal, payload)
            modal.uid = ++context.state.modalIdx

            // Create a promise to resolve/reject our modal actions
            const promise = new Promise((resolve, reject) => {
                modal.resolve = resolve
                modal.reject = reject
            })

            // Add to our list
            context.state.modals.push(modal)

            // Emit open event on event bus
            Vue.prototype.$eventBus.$emit('modalOpen', payload)

            // And return the promise in case we want to actually do something with the modal
            return promise
        },

        dismissModal (context, uid) {
            for (let x = 0; x < context.state.modals.length; x++) {
                let modal = context.state.modals[x]

                if (modal.uid === uid) {
                    modal.dismissing = true

                    setTimeout(() => {
                        context.state.modals.splice(x, 1)
                    }, 350)

                    return
                }
            }
        },

        showAddBrief (context) {
            return context.dispatch('show', { title: 'Brief Us', type: 'brief-add', maskCanDismiss: false })
        },

        showAddBriefMonday (context) {
            return context.dispatch('show', { title: 'Brief Us', type: 'brief-add-monday', maskCanDismiss: false })
        },

        showAddListing (context, payload) {
            let title = !payload ? 'List your space' : 'Edit your space'
            return context.dispatch('show', { title, type: 'listing-add', maskCanDismiss: false, data: payload, fullscreen: true })
        },

        showByronEnquire(context){
            return context.dispatch('show', { title: 'Enquire Now', type: 'byron-enquire', maskCanDismiss: false })
        },

        showContactUsMonday(context){
            return context.dispatch('show', { title: 'Contact Us', type: 'contact-us-monday', maskCanDismiss: false })
        },

        showFullscreenVideo(context, payload) {
            return context.dispatch('show', { type: 'fullscreen-video', maskCanDismiss: false, data: payload, fullscreen: true, headless: true })
        }

    },

}
